import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { GoogleOAuthProvider } from "@react-oauth/google";
// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import { RbacProvider } from "./context/RbacContext";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <RbacProvider>
          <App />
        </RbacProvider>
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </GoogleOAuthProvider>
);
